import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UserOutputCashService from 'mt-react-common/modules/authUserOutputCash/services/UserOutputCashService';

import { addClientNotice } from 'mt-react-common/modules/main/reducers/static/states/clientNotices/reducer';
import ButtonConfirmPopUp from '../../../Common/Buttons/ButtonConfirmPopUp';

class CustomerCancelOrderAction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false
    };
  }

  resendCustomerApproveToken = id => {
    this.setState({ isLoading: true });
    UserOutputCashService.customerCancelPayoutOrder(id).then(result => {
      if (result.status === 200) {
        this.props.onRefreshOutputCashHistoryTable();
      } else {
        this.props.addClientNotice({
          type: 'danger',
          message: result.data.message
        });
      }
      this.setState({ isLoading: false });
      console.log(result);
    });
  };

  render() {
    return (
      <React.Fragment>
        <ButtonConfirmPopUp
          id={'customerCancelOrderAction'}
          confirmText={'Вы уверены что хотите отменить выплату?'}
          buttonSuccessTitle={'Уверен'}
          handleConfirmSuccess={() => {
            if (!this.state.isLoading) {
              this.resendCustomerApproveToken(this.props.id);
            }
          }}
        >
          <a
            data-toggle="tooltip"
            data-container="body"
            data-placement="top"
            href=""
            title={'Отменить заказ на выплату'}
          >
            <i className="fa fa-times-circle" style={{ color: 'red' }} />
          </a>
        </ButtonConfirmPopUp>
      </React.Fragment>
    );
  }
}

CustomerCancelOrderAction.propTypes = {
  id: PropTypes.number.isRequired,
  addClientNotice: PropTypes.func.isRequired,
  onRefreshOutputCashHistoryTable: PropTypes.func.isRequired
};

const mapStateToProps = () => {};

const mapDispatchToProps = dispatch => ({
  addClientNotice: params => dispatch(addClientNotice(params))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerCancelOrderAction);



// WEBPACK FOOTER //
// ./src/components/UserOutputCash/UserOutputCashHistoryTable/_actions/CustomerCancelOrderAction.js